<template>
  <h4 class="text-left mb-2">Then using the template, upload your file</h4>
  <DropZone @drop.prevent="drop" @change="selectedFile" />
  <div v-if="fileName" class="mt-4">
    <span>Uploaded File: {{ fileName }}</span>
    <AppkitIcon
      class="ml-2 hover"
      :icon="'icon-circle-delete-outline'"
      @click="deleteFile"
    />
  </div>
</template>

<script setup lang="ts">
import DropZone from "@/components/custom/DropZone.vue";
import { computed, ref } from "vue";
import AppkitIcon from "@/components/custom/AppkitIcon.vue";
import { useSnackBarStore } from "@/stores/snackBarStore";

const snackBarStore = useSnackBarStore();

const emit = defineEmits<{
  (e: "suppliersUploaded", file: FormData): void;
  (e: "fileDeleted"): void;
}>();

const dropzoneFile = ref([]);

//@ts-ignore
const fileName = computed(() => dropzoneFile.value?.name ?? "");

function drop(event: any) {
  dropzoneFile.value = event.dataTransfer.files[0];
  //@ts-ignore
  var fileExtenstion = dropzoneFile.value.name.split(".");

  if (fileExtenstion.at(-1) != "xlsx" && fileExtenstion.at(-1) != "csv") {
    snackBarStore.showError(
      "Please upload an .xlsx or .csv file",
      "Invalid File Type"
    );
    dropzoneFile.value = [];
  } else {
    emitFile();
  }
}

function selectedFile() {
  //@ts-ignore
  dropzoneFile.value = document.querySelector(".dropzoneFile").files[0];
  emitFile();
}

const emitFile = async () => {
  let formData = new FormData();
  //@ts-ignore
  formData.append("file", dropzoneFile.value);
  emit("suppliersUploaded", formData);
};

function deleteFile() {
  dropzoneFile.value = [];
  emit("fileDeleted");
}
</script>

<style lang="scss">
.hover {
  &:hover {
    cursor: pointer;
  }
}
</style>
